/**
 * Logs para diagnóstico Ads (Links Ads / Facebook Ads) em produção.
 *
 * Filtro no DevTools: MatrizAds
 * Logs HTTP detalhados (request/response): no console execute:
 *   localStorage.setItem('matrizAdsDebug', '1')
 *   e recarregue a página. Para desligar: localStorage.removeItem('matrizAdsDebug')
 */

export const MATRIZ_ADS_TAG = '[MatrizAds]'

export function matrizAdsDebugEnabled() {
  try {
    return localStorage.getItem('matrizAdsDebug') === '1'
  } catch {
    return false
  }
}

export function matrizAdsInfo(screen, step, detail = {}) {
  console.info(`${MATRIZ_ADS_TAG} ${screen}`, step, {
    ...detail,
    t: new Date().toISOString(),
  })
}

export function matrizAdsWarn(screen, step, detail = {}) {
  console.warn(`${MATRIZ_ADS_TAG} ${screen}`, step, {
    ...detail,
    t: new Date().toISOString(),
  })
}

export function matrizAdsErr(screen, step, err) {
  const cfg = err?.config
  const res = err?.response
  console.error(`${MATRIZ_ADS_TAG} ${screen} :: ${step}`, {
    message: err?.message,
    code: err?.code,
    requestUrl: cfg ? `${cfg.baseURL || ''}${cfg.url || ''}` : undefined,
    method: cfg?.method,
    params: cfg?.params,
    status: res?.status,
    statusText: res?.statusText,
    responseData: res?.data,
    t: new Date().toISOString(),
  })
  if (matrizAdsDebugEnabled() && err) {
    console.error(`${MATRIZ_ADS_TAG} stack/raw`, err)
  }
}

export function matrizAdsApiBase() {
  try {
    return (
      process.env.VUE_APP_ROOT_API_URL || '(VUE_APP_ROOT_API_URL indefinido)'
    )
  } catch {
    return '(env indisponível)'
  }
}
